module.exports = __webpack_public_path__ + "img/step3.16ace8a0.png";